// extracted by mini-css-extract-plugin
module.exports = {"LogoContainer":"Logo_LogoContainer__3Qcht","Logo":"Logo_Logo__2hZTg"};